import { useAppSelector } from "../../../store/hooks";
import { AgentIcon } from "./AgentIcon";
import { AuditContextIcon } from "./AuditContextIcon";
import { AuditTrailIcon } from "./AuditTrailIcon";
import { CloudAccountIcon } from "./CloudAccountIcon";
import { ImageIcon } from "./ImageIcon";
import { DomainIcon } from "./DomainIcon";
import { GroupIcon } from "./GroupIcon";
import { GvcIcon } from "./GvcIcon";
import { IdentityIcon } from "./IdentityIcon";
import { IpSetDarkIcon } from "./IpSet/IpSetDarkIcon";
import { IpSetLightIcon } from "./IpSet/IpSetLightIcon";
import { IpSetWhiteIcon } from "./IpSet/IpSetWhiteIcon";
import { KubernetesIcon } from "./KubernetesIcon";
import { LocationIcon } from "./LocationIcon";
import { LogIcon } from "./LogIcon";
import { CatalogDarkIcon } from "./Catalog/CatalogDarkIcon";
import { CatalogLightIcon } from "./Catalog/CatalogLightIcon";
import { CatalogWhiteIcon } from "./Catalog/CatalogWhiteIcon";
import { MetricsIcon } from "./MetricsIcon";
import { OrgIcon } from "./OrgIcon";
import { PaymentMethodIcon } from "./PaymentMethodIcon";
import { PolicyIcon } from "./PolicyIcon";
import { QuotaIcon } from "./QuotaIcon";
import { SecretIcon } from "./SecretIcon";
import { ServiceAccountIcon } from "./ServiceAccountIcon";
import { UsageIcon } from "./UsageIcon";
import { UserIcon } from "./UserIcon";
import { VolumeSetIcon } from "./VolumeSetIcon";
import { WorkloadIcon } from "./WorkloadIcon";

export type Icon =
  | "catalog"
  | "catalogDark"
  | "catalogLight"
  | "catalogWhite"
  | "agent" //
  | "auditctx"
  | "auditTrail"
  | "cloudaccount"
  | "image"
  | "domain"
  | "group"
  | "gvc"
  | "identity"
  | "ipset"
  | "ipsetDark"
  | "ipsetLight"
  | "ipsetWhite"
  | "mk8s"
  | "location"
  | "log"
  | "metrics"
  | "org"
  | "paymentMethod"
  | "policy"
  | "quota"
  | "secret"
  | "serviceaccount"
  | "usage"
  | "user"
  | "volumeset"
  | "workload";

// TODO maybe need to use
const pngIconStyle = { width: 20, height: 20 };

interface Props {
  icon: Icon;
  style?: React.CSSProperties;
  className?: string;
}
export const RenderSvgIcon: React.FC<Props> = ({ icon, style = {}, className = "" }) => {
  const theme = useAppSelector((state) => state.theme.theme);

  if (icon === "agent") {
    return <AgentIcon style={style} className={className} />;
  }
  if (icon === "auditctx") {
    return <AuditContextIcon style={style} className={className} />;
  }
  if (icon === "auditTrail") {
    return <AuditTrailIcon style={style} className={className} />;
  }
  if (icon === "cloudaccount") {
    return <CloudAccountIcon style={style} className={className} />;
  }
  if (icon === "image") {
    return <ImageIcon style={style} className={className} />;
  }
  if (icon === "domain") {
    return <DomainIcon style={style} className={className} />;
  }
  if (icon === "group") {
    return <GroupIcon style={style} className={className} />;
  }
  if (icon === "gvc") {
    return <GvcIcon style={style} className={className} />;
  }
  if (icon === "identity") {
    return <IdentityIcon style={style} className={className} />;
  }
  if (icon === "ipset") {
    if (className.includes("menu-link-icon-active")) {
      return <IpSetWhiteIcon style={style} className={className} />;
    }
    if (theme === "dark") {
      return <IpSetDarkIcon style={style} className={className} />;
    }
    return <IpSetLightIcon style={style} className={className} />;
  }
  if (icon === "ipsetDark") {
    return <IpSetDarkIcon style={style} className={className} />;
  }
  if (icon === "ipsetLight") {
    return <IpSetLightIcon style={style} className={className} />;
  }
  if (icon === "ipsetWhite") {
    return <IpSetWhiteIcon style={style} className={className} />;
  }
  if (icon === "mk8s") {
    return <KubernetesIcon style={style} className={className} />;
  }
  if (icon === "location") {
    return <LocationIcon style={style} className={className} />;
  }
  if (icon === "log") {
    return <LogIcon style={style} className={className} />;
  }
  if (icon === "catalog") {
    if (className.includes("menu-link-icon-active")) {
      return <CatalogWhiteIcon style={style} className={className} />;
    }
    if (theme === "dark") {
      return <CatalogDarkIcon style={style} className={className} />;
    }
    return <CatalogLightIcon style={style} className={className} />;
  }
  if (icon === "catalogDark") {
    return <CatalogDarkIcon style={style} className={className} />;
  }
  if (icon === "catalogLight") {
    return <CatalogLightIcon style={style} className={className} />;
  }
  if (icon === "catalogWhite") {
    return <CatalogWhiteIcon style={style} className={className} />;
  }
  if (icon === "metrics") {
    return <MetricsIcon style={style} className={className} />;
  }
  if (icon === "org") {
    return <OrgIcon style={style} className={className} />;
  }
  if (icon === "paymentMethod") {
    return <PaymentMethodIcon style={style} className={className} />;
  }
  if (icon === "policy") {
    return <PolicyIcon style={style} className={className} />;
  }
  if (icon === "quota") {
    return <QuotaIcon style={style} className={className} />;
  }
  if (icon === "secret") {
    return <SecretIcon style={style} className={className} />;
  }
  if (icon === "serviceaccount") {
    return <ServiceAccountIcon style={style} className={className} />;
  }
  if (icon === "usage") {
    return <UsageIcon style={style} className={className} />;
  }
  if (icon === "user") {
    return <UserIcon style={style} className={className} />;
  }
  if (icon === "volumeset") {
    return <VolumeSetIcon style={style} className={className} />;
  }
  if (icon === "workload") {
    return <WorkloadIcon style={style} className={className} />;
  }

  return null;
};
